import React, { useState } from "react";
import axios from "axios";
import { Button } from "../../../../components/ui/button";
import { Barcode, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Sends the currently-selected (or already-uploaded) product photo to
 * POST /api/admin/ai-read-ean and writes the result back into #ean.
 *
 * Two outcomes:
 *  - Barcode visible & readable → field filled with the digit string
 *  - No barcode found            → field filled with "Does not apply"
 *    (eBay accepts this placeholder for collectibles without GTIN)
 */
export const AISuggestEanButton = ({ selectedFile, existingImageUrl }) => {
  const [loading, setLoading] = useState(false);
  const [info, setInfo] = useState(null);

  const handleClick = async () => {
    if (!selectedFile && !existingImageUrl) {
      setInfo({ kind: "error", text: "Carica prima una foto o salva l'articolo" });
      return;
    }
    setLoading(true);
    setInfo(null);
    try {
      const form = new FormData();
      if (selectedFile) {
        // selectedFile may now be an array of files; take the first one.
        const file = Array.isArray(selectedFile) ? selectedFile[0] : selectedFile;
        if (file) form.append("photo", file);
      } else if (existingImageUrl) {
        form.append("image_url", existingImageUrl);
      }
      const token = sessionStorage.getItem("access_token");
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      const res = await axios.post(`${API}/admin/ai-read-ean`, form, { headers });
      const ean = res.data?.ean || "";
      const source = res.data?.source;
      const input = document.getElementById("ean");
      if (input) input.value = ean;
      setInfo({
        kind: source === "barcode" ? "ok" : "fallback",
        text: source === "barcode" ? `✓ EAN letto: ${ean}` : "Nessun barcode → 'Does not apply'",
      });
    } catch (e) {
      setInfo({ kind: "error", text: e.response?.data?.detail || "Errore AI" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col">
      <Button
        type="button"
        size="sm"
        variant="outline"
        onClick={handleClick}
        disabled={loading}
        className="h-8 px-3 text-xs bg-blue-50 hover:bg-blue-100 border-blue-300 text-blue-700 whitespace-nowrap"
        data-testid="ebay-ean-suggest-btn"
      >
        {loading ? (
          <>
            <Loader2 className="w-3 h-3 mr-1 animate-spin" />
            Lettura…
          </>
        ) : (
          <>
            <Barcode className="w-3 h-3 mr-1" />
            Suggerisci
          </>
        )}
      </Button>
      {info && (
        <span
          className={
            "text-[10px] mt-0.5 " +
            (info.kind === "ok"
              ? "text-green-600"
              : info.kind === "fallback"
              ? "text-amber-600"
              : "text-red-600")
          }
        >
          {info.text}
        </span>
      )}
    </div>
  );
};
